import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flip from 'react-reveal/Flip';

const styles = theme => ({
  customGrid:{
    position: 'relative',
    paddingBottom: 16,
    marginTop: 20,
    [theme.breakpoints.up('md')]: {
        maxWidth: '14.23%',
        flexBasis: '14.23%'
    }
  }
})
class OurBrands extends React.Component{
    constructor(props){
        super(props);
        this.state = {
         items:[
            { 
                img: 'https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/Duwun-logo-with-background.png', 
                title: 'Duwun', 
                description: "News and viral", 
                fbLink: 'https://www.facebook.com/duwun/'  
            },
            { 
                img: 'https://duwun.sgp1.cdn.digitaloceanspaces.com/130322/conversions/duwun-tv-logo-teaser.jpg', 
                title: 'Duwun TV', 
                description: "Entertainment TV", 
                fbLink: 'https://www.facebook.com/duwun.tv/'  
            },
            { 
                img: 'https://duwun.sgp1.cdn.digitaloceanspaces.com/122904/conversions/duwun-sports-logo-teaser.jpg', 
                title: 'Duwun Sports', 
                description: "local and international sports", 
                fbLink: 'https://www.facebook.com/duwun.sports/'  
            },
            { 
                img: 'https://duwun.sgp1.cdn.digitaloceanspaces.com/122870/conversions/duwun-tech-logo-teaser.jpg', 
                title: 'Duwun Tech', 
                description: "Tech and young startps", 
                fbLink: 'https://www.facebook.com/duwun.tech/'  
            },
            { 
                img: 'https://duwun.sgp1.cdn.digitaloceanspaces.com/122844/conversions/duwun-celeyatkwat-logo-teaser.jpg', 
                title: 'Cele Yatkwat', 
                description: "Celebrity vertical", 
                fbLink: 'https://www.facebook.com/duwun.celeyatkwat/'  
            },
            { 
                img: 'https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/madi-logo.jpg', 
                title: 'Madi', 
                description: "Women empowerment and culture", 
                fbLink: 'https://www.facebook.com/duwun.madi/'  
            },
            { 
                img: 'https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/ayathar-logo.jpg', 
                title: 'Ayathar', 
                description: "Foodie DNA", 
                fbLink: 'https://www.facebook.com/duwun.ayathar/'  
            },
            ]
        };
      }  
    render(){
        const { classes, items } = this.props;
        return(
            <Grid container  
            direction="row"
            // justify="space-between"
            justify="space-evenly"
            className="brands advertise-layout"
            style={{marginBottom: '4em'}}
            >
            <Grid item md={12} xs={12} >
                <h2 style={{ padding: '30px 0px 0px', color: '#ed7123', fontSize: 30 }}> Our Brands</h2>
            </Grid>
            {
                this.state.items.map((item, i) => {
                    return(
                        <React.Fragment key={i}>
                            <Grid item md={1} sm={6} xs={6} classes={{item: classes.customGrid}}>
                               
                            <Flip left>
                                <div className="clipwrapper">
                                   
                                        <CardMedia
                                            style={{height: '100%'}}
                                            image={item.img}
                                            title={item.title}
                                        />
                                   
                                </div>
                                </Flip>
                                <div className="brands-item">
                                    <h4>{item.title}</h4>
                                    <Typography component="p" gutterBottom >
                                        {item.description}
                                    </Typography>
                                    <a href={item.fbLink} target="_blank">
                                       <FontAwesomeIcon icon={['fab', 'facebook-f']} className="customIcon"></FontAwesomeIcon>
                                    </a>
                                </div>
                              
                            </Grid>
                        </React.Fragment>
                    )
                })
            }
            </Grid>
        )
    }
}
export default withStyles(styles)(OurBrands);